
export const tipoRegistro = (state = {}, action) => {

    switch (action.type) {
        case "setTipoRegistro": const tmp = action.value;
            return { ...state, ...tmp };
        default:
            return state;
    }

}